import React from "react";
import { motion } from "framer-motion";

function UtilityButton({
  children,
  isDark = false,
  style = {},
  ...props
}) {
  return (
    <motion.button
      whileHover={{
        y: -1,
        scale: 1.01,
      }}
      whileTap={{
        scale: 0.985,
      }}
      transition={{
        type: "spring",
        stiffness: 320,
        damping: 22,
      }}
      style={{
        position: "relative",
        overflow: "hidden",

        padding: "13px 16px",
        borderRadius: "14px",

        border: isDark
          ? "1px solid rgba(148,163,184,0.12)"
          : "1px solid rgba(15,23,42,0.08)",

        background:
          style.background ||
          (isDark
            ? "rgba(15,23,42,0.88)"
            : "#e5e7eb"),

        color:
          style.color ||
          (isDark
            ? "#f8fafc"
            : "#111827"),

        fontWeight: 700,
        cursor: "pointer",

        backdropFilter: "blur(18px)",
        WebkitBackdropFilter:
          "blur(18px)",

        boxShadow: isDark
          ? "0 10px 30px rgba(2,6,23,0.45)"
          : "0 4px 14px rgba(15,23,42,0.06)",

        transition:
          "all 180ms ease",

        ...style,
      }}
      {...props}
    >
      <motion.div
        initial={{
          x: "-120%",
        }}
        animate={{
          x: "120%",
        }}
        transition={{
          duration: 3.2,
          repeat: Infinity,
          ease: "linear",
        }}
        style={{
          position: "absolute",
          inset: 0,
          background: isDark
            ? "linear-gradient(90deg,transparent,rgba(255,255,255,0.05),transparent)"
            : "linear-gradient(90deg,transparent,rgba(255,255,255,0.35),transparent)",
          zIndex: 1,
        }}
      />

      <span
        style={{
          position: "relative",
          zIndex: 2,
        }}
      >
        {children}
      </span>
    </motion.button>
  );
}

export default UtilityButton;